var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center align-items-center",staticStyle:{"height":"calc(100vh - 164px)"}},[_c('h1',[_vm._v("Hello "+_vm._s(this.$store.user))])])}
var staticRenderFns = []

export { render, staticRenderFns }